module.exports = __webpack_public_path__ + "static/space-background-d1dac6dec3dfddba0919c6e6702f8abb.png";